<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">New Project</p>
    </header>
    <section class="modal-card-body">
      <b-steps :hasNavigation="false" v-model="activeStep">
        <b-step-item step="1" label="Subject">
          <ValidationObserver slim ref="observer1" v-slot="{ handleSubmit }">
            <item-title
              :title="project.title"
              :itemType="'project'"
              :displaySuccess="false"
              @updateTitle="project.title = $event"
            />

            <project-character
              :character="project.character"
              :version="project.version"
              :universe="project.universe"
              @updateCharacter="project.character = $event"
              @updateVersion="project.version = $event"
              @updateUniverse="project.universe = $event"
            />
          </ValidationObserver>
        </b-step-item>

        <b-step-item step="2" label="Details">
          <item-description
            :description="project.description"
            @updateDescription="project.description = $event"
          />

          <item-tags
            :tags="project.tag_list"
            :placeholder="'WCS, Comic Con, Photoshop...'"
            @updateTags="project.tag_list = $event"
          />

          <item-visibility
            :hidden="project.hidden"
            :itemType="'project'"
            @updateHidden="project.hidden = $event"
          />
        </b-step-item>
      </b-steps>
    </section>

    <footer class="modal-card-foot">
      <span class="card-footer-item">
        <b-button
          @click="previousStep"
          :disabled="onFirstStep"
          outlined
          type="is-danger"
          icon-pack="mdi"
          icon-left="skip-previous"
        >
          Previous
        </b-button>
      </span>

      <span class="card-footer-item">
        <b-button
          @click="nextStep"
          v-if="!onLastStep"
          outlined
          type="is-success"
          icon-pack="mdi"
          icon-right="skip-next"
        >
          Next
        </b-button>

        <b-button
          @click="createProject"
          v-else
          type="is-success"
          icon-pack="mdi"
          icon-right="check"
        >
          Create
        </b-button>
      </span>
      <span class="card-footer-item">
        <b-button @click="$parent.close()"> Close </b-button>
      </span>
    </footer>
  </div>
</template>

<script>
// Mixins
import { notificationMixin } from '@/mixins/notificationMixin'
import { formStepsMixin } from '@/mixins/formStepsMixin'

// Components
import { ValidationObserver } from 'vee-validate'

// Attributes
import ItemTitle from '@/components/Attributes/ItemTitle'
import ProjectCharacter from '@/components/Attributes/ProjectCharacter'
import ItemDescription from '@/components/Attributes/ItemDescription'
import ItemTags from '@/components/Attributes/ItemTags'
import ItemVisibility from '@/components/Attributes/ItemVisibility'

export default {
  mixins: [notificationMixin, formStepsMixin],
  components: {
    ValidationObserver,
    ItemTitle,
    ProjectCharacter,
    ItemDescription,
    ItemTags,
    ItemVisibility
  },
  data () {
    return {
      steps: 2,
      selectedCategory: null,
      selectedPart: null,
      project: {
        character: null,
        universe: null,
        version: null,
        description: null,
        tag_list: [],
        title: null,
        hidden: true
      }
    }
  },
  methods: {
    createProject () {
      this.$store
        .dispatch('projects/create', this.project)
        .then((resp) => {
          this.$router.push(`/projects/${resp.data.data.id}`)
        })
        .catch((error) => {
          console.log(error.response)
          this.alertError()
        })
    }
  }
}
</script>
